import React from 'react';

const Contribute = () => <p>Contribute here</p>;

export default Contribute;
